import { useDispatch, useSelector } from 'react-redux'
import { setShowReturnApplicationModal } from '../../../../../Store/GeneralReducer/generalActions'
import FullApplicationInfo from '../../../../../Components/SearchResultsComponents/FullApplicationInfo/FullApplicationInfo'
import FullApplicationInfoOld from '../../../../../Components/SearchResultsComponents/FullApplicationInfoOld/FullApplicationInfoOld';

export const TaskReturn = () => {
    const dispatch = useDispatch()
    const { returningApplicationData, returningApplicationId } = useSelector(state => state.applications)
    const { showReturnApplication } = useSelector(state => state.general)
    return (
        showReturnApplication && (returningApplicationData) ?
            <>
                <div className="FullInfoModalBg" onClick={() => { dispatch(setShowReturnApplicationModal(false)) }} />
                <FullApplicationInfoOld
                    applicationId={returningApplicationId}
                    clickToClose={() => dispatch(setShowReturnApplicationModal(false))}
                    application={returningApplicationData}
                    first={true}
                    last={true}
                    commentMessage={returningApplicationData ? returningApplicationData.rating_comment : ""}
                />
            </> :
            null
    )
}